import React, { useState } from "react";
import { translationLanguages } from "../../utils/list";
import { Constants } from "@videosdk.live/react-sdk";
import logger from '../../utils/logger';
export default function ToolsDropdown({
  meetingRole,
  startWhiteboard,
  isLiveStreaming,
  handleStopLiveStream,
  setShowLiveStreamModal,
  setShowToolsDropdown,
  showCaptionsDropdown,
  setShowCaptionsDropdown,
  mMeeting,
  isMobile,
  meetingSettings,
  translationEnabled,
  setTranslationEnabled,
  translationStatus,
  startTranslation,
  changeTranslationLanguage,
  selectedLanguage,
  setSelectedLanguage,
  showLiveStreamModal,
  liveStreamPlatforms,
  setLiveStreamPlatforms,
  streamingCredentials,
  setStreamingCredentials,
  handleStartLiveStream,
  startTranscription,
  stopTranscription,
  transcriptionEnabled,
  setTranscriptionEnabled,
  showBreakoutRoomsModal,
  setShowBreakoutRoomsModal,
}) {
  React.useEffect(() => {
    return () => {
      setShowCaptionsDropdown(false);
      setShowLiveStreamModal(false);
    };
  }, []);
  const [animateOpen, setAnimateOpen] = React.useState(false);

  // Debug: Log when modal state changes
  React.useEffect(() => {
    if (showBreakoutRoomsModal) {
      logger("log", "🟣 ToolsDropdown: showBreakoutRoomsModal prop is true, modal should be visible");
    }
  }, [showBreakoutRoomsModal]);

  React.useEffect(() => {
    const timer = setTimeout(() => setAnimateOpen(true), 10);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div
      data-tools-dropdown
      className={`absolute top-full right-0 mt-2 w-80 bg-primaryDarkBlue rounded-lg shadow-xl border border-gray-600 z-[10000] transform transition-all duration-300 ease-out ${animateOpen
        ? "opacity-100 translate-y-0 scale-100"
        : "opacity-0 -translate-y-2 scale-95"
        }`}
    >
      {/* Tools Grid */}
      <div className="grid grid-cols-3 gap-5 p-6">
        {/* Whiteboard Option */}
        {meetingRole === "moderator" && (
          <button
            onClick={() => {
              startWhiteboard();
              setShowToolsDropdown(false);
            }}
            className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
          >
            <img
              src="/icons/whiteboard.svg"
              alt="Whiteboard"
              className="flex-shrink-0 w-6 h-6"
            />
            <span className="text-xs font-medium text-center whitespace-nowrap">
              Whiteboard
            </span>
          </button>
        )}

        {/* Captions Option */}
        <button
          data-ai-captions-button
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setShowCaptionsDropdown((prev) => !prev);
            // Ensure livestream panel is closed when opening captions
            setShowLiveStreamModal(false);
          }}
          className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
        >
          {!showCaptionsDropdown ? (
            <img
              src="/icons/aiCaption.svg"
              alt="Captions"
              className="flex-shrink-0 w-6 h-6"
            />
          ) : (
            <img
              src="/icons/aiCaptionOn.svg"
              alt="Captions"
              className="flex-shrink-0 w-6 h-6"
            />
          )}
          <span className="text-xs font-medium text-center whitespace-nowrap">
            AI Captions
          </span>
        </button>

        {/* AI Note Taker - moderators and co-hosts only */}
        {["moderator", "co-host"].includes(meetingRole) && (
          <button
            onClick={() => {
              const newState = !transcriptionEnabled;
              if (newState) {
                if (mMeeting && mMeeting.transcriptionState == Constants.transcriptionEvents.TRANSCRIPTION_STOPPED) {
                  startTranscription();
                }
              } else {
                if (mMeeting && mMeeting.transcriptionState == Constants.transcriptionEvents.TRANSCRIPTION_STARTED) {
                  stopTranscription();
                }
              }
              setTranscriptionEnabled(newState);
              setShowToolsDropdown(false);
            }}
            className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
          >
            <img
              src={
                transcriptionEnabled
                  ? "/icons/aiNoteTakerOn.svg"
                  : "/icons/aiNoteTaker.svg"
              }
              alt="AI Note Taker"
              className="flex-shrink-0 w-6 h-6"
            />
            <span className="text-xs font-medium text-center whitespace-nowrap">
              AI Note Taker
            </span>
          </button>
        )}

        {/* Live Stream Option */}
        {["moderator", "co-host"].includes(meetingRole) && (
          <button
            onClick={() => {
              setShowLiveStreamModal((prev) => !prev);
              setShowCaptionsDropdown(false);
            }}
            className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
          >
            <img
              src={
                showLiveStreamModal
                  ? "/icons/livestreamOn.svg"
                  : "/icons/livestream.svg"
              }
              alt="Live Stream"
              className="flex-shrink-0 w-6 h-6"
            />
            <span className="text-xs font-medium text-center whitespace-nowrap">
              Live Stream
            </span>
          </button>
        )}

        {/* Breakout Rooms Option */}
        {["moderator", "co-host"].includes(meetingRole) && (
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              // Set modal to open - this is now managed at TopBar level
              setShowBreakoutRoomsModal(true);

              // Close the ToolsDropdown after opening modal
              setShowToolsDropdown(false);
            }}
            className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
          >
            <img
              src="/icons/breakoutRoom.png"
              alt="Breakout Rooms"
              className="flex-shrink-0 w-6 h-6"
            />
            <span className="text-xs font-medium text-center whitespace-nowrap">
              Breakout Rooms
            </span>
          </button>
        )}

        {/* {user?.plan == "Business" &&
        ["moderator", "co-host"].includes(meetingRole) && (
          <button
            onClick={() => {
              setShowPollsModal(true);
              setShowToolsDropdown(false);
              setShowLayoutDropdown(false);
              setShowVideoDropdown(false);
              setShowAudioInputDropdown(false);
            }}
            className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
          >
            <svg
              className="flex-shrink-0 w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
              />
            </svg>
            <span className="text-xs font-medium text-center whitespace-nowrap">
              Polls
            </span>
          </button>
        )} */}
      </div>

      {/* Divider */}
      {(showCaptionsDropdown || showLiveStreamModal) && (
        <div className="h-[1px] bg-white mx-6"></div>
      )}

      {/* Captions Settings Section (animated) */}
      <div
        data-captions-dropdown
        className={`transition-all duration-300 ease-out ${showCaptionsDropdown
          ? "opacity-100 translate-y-0 max-h-[600px] p-4"
          : "opacity-0 -translate-y-2 max-h-0 p-0 overflow-hidden pointer-events-none"
          }`}
      >
        {/* Caption Toggle */}
        <div className="px-4 py-3">
          <div className="flex items-center justify-center">
            <div className="flex bg-gray-700 p-1 rounded mt-2">
              <button
                onClick={() => {
                  if (translationEnabled) {
                    // stopTranslation();
                  }
                  setTranslationEnabled(false);
                }}
                className={`px-3 py-1 text-xs font-medium transition-colors ${!translationEnabled
                  ? "bg-[#7700ff] text-white"
                  : "text-gray-400 hover:text-white"
                  }`}
              >
                OFF
              </button>
              <button
                onClick={() => {
                  // if (!translationEnabled) {
                  //   if (translationStatus === "stopped") {
                  //     startTranslation();
                  //   }
                  // }
                  if (mMeeting && mMeeting.translationState == Constants.translationEvents.TRANSLATION_STOPPED) {
                    startTranslation();
                  }
                  setTranslationEnabled(true);
                }}
                className={`px-3 py-1 text-xs font-medium transition-colors ${translationEnabled
                  ? "bg-[#7700FF] text-white"
                  : "text-gray-400 hover:text-white"
                  }`}
              >
                ON
              </button>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {translationEnabled && translationStatus === "starting" && (
          <div className="px-3 py-6">
            <div className="flex flex-col items-center justify-center gap-4">
              {/* Animated Loader */}
              <div className="relative w-16 h-16">
                <div className="absolute inset-0 border-4 border-[#7700ff]/20 rounded-full"></div>
                <div className="absolute inset-0 border-4 border-transparent border-t-[#7700ff] rounded-full animate-spin"></div>
                <div
                  className="absolute inset-2 border-4 border-transparent border-r-[#7700ff] rounded-full animate-spin"
                  style={{
                    animationDirection: "reverse",
                    animationDuration: "0.8s",
                  }}
                ></div>
              </div>
              {/* Loading Text */}
              <div className="text-center">
                <p className="text-white text-sm font-medium mb-1">
                  Please wait while loading the languages...
                </p>
                <p className="text-gray-400 text-xs">
                  This may take a few moments
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Translation Option */}
        {translationEnabled && translationStatus == "started" && (
          <div className="px-3 py-3">
            <div className="text-white text-center text-sm tracking-widest font-medium mb-2">
              TRANSLATE TO
            </div>
            <div className="relative">
              <select
                value={selectedLanguage}
                onChange={(e) => {
                  changeTranslationLanguage(e.target.value);
                  setSelectedLanguage(e.target.value);
                }}
                className="w-full bg-[#060621] text-white text-sm px-3 py-4 pr-12 rounded-2xl border border-white focus:outline-none focus:border-[#7700ff] appearance-none"
              >
                {translationLanguages.map((language) => (
                  <option
                    key={language.code}
                    value={language.code}
                    selected={language.code === selectedLanguage}
                  >
                    {language.language}
                  </option>
                ))}
              </select>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white pointer-events-none"
              >
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </div>
          </div>
        )}
      </div>

      {/* Live Streaming Modal (animated) */}
      <div
        className={`transition-all duration-300 ease-out ${showLiveStreamModal
          ? "opacity-100 translate-y-0 max-h-[1200px] mt-3 p-4"
          : "opacity-0 -translate-y-2 max-h-0 mt-0 p-0 overflow-hidden pointer-events-none"
          }`}
      >
        {/* Platform Selection */}
        <h1 className="text-white text-center text-sm tracking-[3px] font-medium mb-2">
          SELECT YOUR PLATFORM
        </h1>
        <div className="space-y-4 mb-6">
          {/* YouTube */}
          <div className="space-y-3 border-b border-gray-700 pb-3">
            <div className="flex items-center justify-start p-4 ">
              <label className="relative inline-flex items-center cursor-pointer mr-5">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={liveStreamPlatforms.youtube}
                  onChange={(e) =>
                    setLiveStreamPlatforms((prev) => ({
                      ...prev,
                      youtube: e.target.checked,
                    }))
                  }
                />
                <div className="w-9 h-5 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-red-600"></div>
              </label>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                  <img src="/icons/yt.svg" alt="YouTube" className="w-8 h-8" />
                </div>
                <div>
                  <div className="font-medium">YouTube</div>
                </div>
              </div>
            </div>
            <div
              className={`pl-12 space-y-2 overflow-hidden transition-all duration-300 ease-out ${liveStreamPlatforms.youtube
                ? "opacity-100 max-h-44 translate-y-0"
                : "opacity-0 max-h-0 -translate-y-2 pointer-events-none"
                }`}
            >
              <input
                type="text"
                placeholder="Stream URL"
                value={streamingCredentials.youtube.url}
                onChange={(e) =>
                  setStreamingCredentials((prev) => ({
                    ...prev,
                    youtube: { ...prev.youtube, url: e.target.value },
                  }))
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-red-600"
              />
              <input
                type="text"
                placeholder="Stream Key"
                value={streamingCredentials.youtube.key}
                onChange={(e) =>
                  setStreamingCredentials((prev) => ({
                    ...prev,
                    youtube: { ...prev.youtube, key: e.target.value },
                  }))
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-red-600"
              />
            </div>
          </div>

          {/* Facebook */}
          <div className="space-y-3 border-b border-gray-700 pb-3">
            <div className="flex items-center justify-start p-4 ">
              <label className="relative inline-flex items-center cursor-pointer mr-5">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={liveStreamPlatforms.facebook}
                  onChange={(e) =>
                    setLiveStreamPlatforms((prev) => ({
                      ...prev,
                      facebook: e.target.checked,
                    }))
                  }
                />
                <div className="w-9 h-5 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
              </label>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                  <img src="/icons/fb.svg" alt="Facebook" className="w-8 h-8" />
                </div>
                <div>
                  <div className="font-medium">Facebook</div>
                </div>
              </div>
            </div>
            <div
              className={`pl-12 space-y-2 overflow-hidden transition-all duration-300 ease-out ${liveStreamPlatforms.facebook
                ? "opacity-100 max-h-44 translate-y-0"
                : "opacity-0 max-h-0 -translate-y-2 pointer-events-none"
                }`}
            >
              <input
                type="text"
                placeholder="Stream URL"
                value={streamingCredentials.facebook.url}
                onChange={(e) =>
                  setStreamingCredentials((prev) => ({
                    ...prev,
                    facebook: { ...prev.facebook, url: e.target.value },
                  }))
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-600"
              />
              <input
                type="text"
                placeholder="Stream Key"
                value={streamingCredentials.facebook.key}
                onChange={(e) =>
                  setStreamingCredentials((prev) => ({
                    ...prev,
                    facebook: { ...prev.facebook, key: e.target.value },
                  }))
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-600"
              />
            </div>
          </div>

          {/* LinkedIn */}
          <div className="space-y-3 ">
            <div className="flex items-center justify-start p-4 ">
              <label className="relative inline-flex items-center cursor-pointer mr-5">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={liveStreamPlatforms.linkedin}
                  onChange={(e) =>
                    setLiveStreamPlatforms((prev) => ({
                      ...prev,
                      linkedin: e.target.checked,
                    }))
                  }
                />
                <div className="w-9 h-5 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-700"></div>
              </label>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                  <img
                    src="/icons/linkedin.svg"
                    alt="LinkedIn"
                    className="w-8 h-8"
                  />
                </div>
                <div>
                  <div className="font-medium">LinkedIn</div>
                </div>
              </div>
            </div>
            <div
              className={`pl-12 space-y-2 overflow-hidden transition-all duration-300 ease-out ${liveStreamPlatforms.linkedin
                ? "opacity-100 max-h-44 translate-y-0"
                : "opacity-0 max-h-0 -translate-y-2 pointer-events-none"
                }`}
            >
              <input
                type="text"
                placeholder="Stream URL"
                value={streamingCredentials.linkedin.url}
                onChange={(e) =>
                  setStreamingCredentials((prev) => ({
                    ...prev,
                    linkedin: { ...prev.linkedin, url: e.target.value },
                  }))
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-700"
              />
              <input
                type="text"
                placeholder="Stream Key"
                value={streamingCredentials.linkedin.key}
                onChange={(e) =>
                  setStreamingCredentials((prev) => ({
                    ...prev,
                    linkedin: { ...prev.linkedin, key: e.target.value },
                  }))
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-700"
              />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 justify-end">
          <button
            className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-white text-white hover:bg-white/10"
            onClick={() => setShowLiveStreamModal(false)}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-[#00C853] text-[#00C853] hover:bg-white/10"
            onClick={() => handleStartLiveStream(liveStreamPlatforms)}
          >
            Go Live
          </button>
        </div>
      </div>

      {/* Breakout Rooms Modal is now rendered at TopBar level to persist when ToolsDropdown closes */}
    </div>
  );
}
